import InputField from "@/components/common/InputField/InputField";
import React, { useState, useEffect, useRef } from "react";
import { Button, Form, Container, Row, Col, Table } from "react-bootstrap";
import { FaPlus } from "react-icons/fa";
import DynamicModal from "./DynamicModal/DynamicModal";
import LicenseInfoTable from "./LicenseInfoTable";
import {
  getLicenseAddressRequiredStateList,
  getRequestId,
} from "@/api/LoginSignup";
import { encrypt } from "@/utils/crypto";
import {
  verifyLicenseDetails,
  sendVerificationCode,
  deleteUser,
  deleteLicense,
  checkDeletedUserEmail,
  getLicenseDetails,
  saveUserDetails,
  getCitiesByState,
  getUserProfile,
  getAllLicenseDetails,
  updateUserLicense,
  insertUserLicense,
  validateChangeEmail,
  isUserEmailVerified,
  changePassword,
  checkValidEmailAddress,
  getLocation,
  getCityListForState,
  saveBuyerProfile,
  downloadInfo,
  agentActiveBids,
  getBrokerAffiliateNames,
  uploadProfilePhoto,
  removeProfilePhoto,
  getProfilePhotoUrl,
} from "@/api/myProfile";
import { getUserRecentSearch } from "@/api/home";
import { useSelector, useDispatch, batch } from "react-redux";
import { toast } from "react-toastify";
import ConfirmationModel from "@/components/common/ConfirmationModel/ConfirmationModel";
import ChangeEmailModal from "./ChangeEmailPopup";
import { formatDisplayDate, parseDateString } from "@/utils/dateFormatter";
import { Modal } from "react-bootstrap";
import IdologyVerification from "@/components/IdologyVerification/IdologyVerification";
import { getSavedSearchAndPropertyCount } from "@/api/savedSearch";
import {
  deleteCorporateLicence,
  editCorporateDetail,
  insertCorporateLicence,
  isPhoneNoInUse,
  updateCorporateLicence,
} from "@/api/bid";
import LoadingText from "@/components/loader/LoadingText";
import LoadedText from "@/components/loader/LoadedText";
import SetPasswordModal from "./SetPasswordModal";
import { generateRandomID } from "@/utils/generateRandomID";
import useAuth from "@/components/common/header/useAuth";
import {
  setLoginCallLocation,
  setLoginModal,
  setLoginTab,
} from "@/redux/login/loginSlice";
import { AgentLiecenseErrorMsgs } from "@/setting";
import { validateForm } from "@/utils/formValidator";
import DashboardSectionWrapper from "../components/DashboardSectionWrapper";
import RoleConfirmationModal from "./RoleConfirmationModal";

import PhotoUpload from "./components/PhotoUpload";
import BioSection from "./components/BioSection";
import { FaCirclePlus } from "react-icons/fa6";
import { useLocation, useNavigate } from "react-router";
import { useUnsavedChanges } from "../components/UnsavedChangesProvider";
import { setProfileInfo } from "@/redux/user/userSlice";
import { setUserDetailsSlices } from "@/redux/auth/authSlice";
import { selectStateList } from "@/redux/common/commonSlice";
import {
  trackApiCall,
  trackButtonClick,
  trackPageMount,
} from "@/utils/analytics";

const MyProfile = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const shouldFocusPhoneField = location.state?.focusPhoneField;
  const trackingTimeoutRef = useRef(null);
  const formRefs = useRef({});

  const dispatch = useDispatch();

  const stateList = useSelector(selectStateList);
  const userData = useSelector((state) => state?.auth?.authData);
  const currentEmail = userData?.emailId || "";

  const { isUserLoggedIn, userSignOut } = useAuth();

  const [errors, setErrors] = useState({});
  const [showMore, setShowMore] = useState(false);
  const [showIdealogyModal, setShowIdologyModal] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [resetPasswordModalState, setResetPasswordModalState] = useState(false);
  const [idolodySuccess, setIdologySuccess] = useState(false);

  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isProfileLoading, setIsProfileLoading] = useState(false);
  const [cities, setCities] = useState([]);
  const [userRoles, setUserRoles] = useState([]);
  const [agentLicenseInfo, setAgentLicenseInfo] = useState([]);
  const [agentCorpLicenseInfo, setAgentCorpLicenseInfo] = useState([]);
  const [licenses, setLicenses] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showLicenseTable, setShowLicenseTable] = useState("");
  const [cityForLiecense, setCitiesForLiecnse] = useState([]);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [submitUserForm, setUserSubmitForm] = useState(false);
  const [userType, setUserType] = useState("");
  const [modalMode, setModalMode] = useState("");
  const [initialValues, setInitialValues] = useState(null);
  const [initalCorpValues, setInitialCorpValues] = useState(null);
  const [licenseData, setLicenseData] = useState(null);
  const [showLicenseModal, setShowLicenseModal] = useState(false);
  const [IdologyVerified, setIdologyVerified] = useState(false);
  const [selectedLicense, setSelectedLicense] = useState({
    agentLicenseAddress1: "",
    agentLicenseAddress2: "",
    agentLicenseCity: "",
    agentLicenseZip: "",
    affiliatedCompany: "",
    licenseNumber: "",
    stateId: "",
    agentLicenseState: "",
    licenceExpiryDate: "",
    cityFromDropDown: false,
  });
  const [showRoleTypeModal, setShowRoleTypeModal] = useState(false);
  const [errorSubmitting, setErrorSubmitting] = useState("");
  const [licenseType, setLicenseType] = useState("Indv");
  const [userProfileData, setUserProfileData] = useState(null);
  const [shouldRefresh, setShouldRefresh] = useState(false);
  const [licenseLoading, setLicenseLoading] = useState(false);
  const [licenseCityDropDowm, setLicenseCityDropDown] = useState("");
  const [userProfileStatus, setUserProfileStatus] = useState("");
  const { setHasUnsavedChanges } = useUnsavedChanges();
  const [roleMessage, setRoleMessage] = useState("");
  const [licenseErrMsg, setLicenseErrMsg] = useState("");
  const [profilePhotoUrl, setProfilePhotoUrl] = useState(null);
  const [logoUrl, setLogoUrl] = useState(null);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    brokerTitle: "",
    emailId: "",
    userId: "",
    phoneNumber: "",
    companyName: "",
    websiteUrl: "",
    linkedinUrl: "",
    bio: "",
    photoPath: "",
    logoPath: "",
    address: {
      address1: "",
      address2: "",
      city: "",
      cityFromDropDown: false,
      state: "",
      zip: "",
    },
    userRoles: [],
    smsOptInStatus: null,
  });

  const [licenseDetails, setLicenseDetails] = useState({
    licenseNumber: "",
    state: "",
  });
  const [emailVerification, setEmailVerification] = useState(false);
  const [emailVerificationError, setEmailVerificationError] = useState("");
  const [filledFieldsCount, setFilledFieldsCount] = useState(1);
  const [previouslyFilledFields, setPreviouslyFilledFields] = useState("");

  const [onlyAgentRole, setOnlyAgentRole] = useState(false);
  const [brokerageName, setBrokerageName] = useState("");
  const [isBrokerAffiliate, setIsBrokerAffiliate] = useState(false);
  const [brokerAffiliateNames, setBrokerAffiliateNames] = useState([]);
  const [selectedBrokerageAffiliateName, setSelectedBrokerageAffiliateName] =
    useState("");
  const [selectedBrokerageAffiliateId, setSelectedBrokerageAffiliateId] =
    useState("");

  const fetchBrokerAffiliateNames = async () => {
    try {
      const response = await getBrokerAffiliateNames();
      if (response?.status === "SUCCESS" && Array.isArray(response.data)) {
        setBrokerAffiliateNames(response.data);
      } else {
        setBrokerAffiliateNames([]);
        if (response?.status === "ERROR") {
          console.error("Failed to fetch broker affiliates:", response.error);
        }
      }
    } catch (error) {
      console.error("Unexpected error fetching broker affiliates:", error);
      setBrokerAffiliateNames([]);
    }
  };

  const handleBrokerAffiliateChange = (e) => {
    const isChecked = e.target.value === "Yes";
    setIsBrokerAffiliate(isChecked);
    setHasUnsavedChanges(true);

    if (!isChecked) {
      setSelectedBrokerageAffiliateName("");
      setSelectedBrokerageAffiliateId("");
      setErrors((prev) => ({
        ...prev,
        brokerAffiliateName: "",
      }));
    }
  };

  const handleBrokerageNameChange = (e) => {
    setHasUnsavedChanges(true);
    const selectedName = e.target.value;
    const selectedAffiliate = brokerAffiliateNames.find(
      (affiliate) => affiliate.name === selectedName
    );

    setSelectedBrokerageAffiliateName(selectedName);
    setSelectedBrokerageAffiliateId(selectedAffiliate?.id || "");
    setErrors((prev) => ({
      ...prev,
      brokerAffiliateName: "",
    }));
  };

  const [isBioSaving, setIsBioSaving] = useState(false);

  const handleBioSave = async (bioText) => {
    setIsBioSaving(true);
    try {
      const updatedFormData = { ...formData, bio: bioText };
      setFormData(updatedFormData);

      const bioPayload = {
        address: {
          address1: formData.addressLine1 || "",
          address2: formData.addressLine2 || "",
          city: formData.city || "",
          cityFromDropDown: false,
          state: formData.state || "",
          zip: formData.zipCode || "",
        },
        companyName: brokerageName || "",
        emailId: formData.emailId || "",
        firstName: formData.firstName || "",
        lastName: formData.lastName || "",
        brokerTitle: formData.brokerTitle || null,
        phoneNumber: formData.phoneNumber || "",
        websiteUrl: formData.websiteUrl || "",
        linkedInUrl: formData.linkedinUrl || null,
        agentBio: bioText,
        photoPath: formData.profilePhoto || "",
        logoPath: formData.logo || "",
        smsOptInStatus:
          formData.smsOptInStatus === "Yes"
            ? "Y"
            : formData.smsOptInStatus === "No"
            ? "N"
            : null,
        userId: formData.userId || "",
        userRoles: [formData.role || "AGENT"],
        brokerAffiliateAgent: isBrokerAffiliate,
        brokerAffiliateId: isBrokerAffiliate
          ? selectedBrokerageAffiliateId
          : null,
        brokerAffiliateName: isBrokerAffiliate
          ? selectedBrokerageAffiliateName
          : null,
      };

      const response = await saveUserDetails(bioPayload);
      if (response?.status === "SUCCESS") {
        toast.success("Bio saved successfully");
      } else {
        // Revert formData on failure
        setFormData((prev) => ({ ...prev, bio: formData.bio }));
        toast.error("Failed to save bio. Please try again.");
        throw new Error("Save failed");
      }
    } catch (error) {
      // Revert formData on error
      setFormData((prev) => ({ ...prev, bio: formData.bio }));
      toast.error("Failed to save bio. Please try again.");
      throw error; // Re-throw so BioSection keeps modal open
    } finally {
      setIsBioSaving(false);
    }
  };

  const handleBioDelete = async () => {
    setIsBioSaving(true);
    try {
      const bioPayload = {
        address: {
          address1: formData.addressLine1 || "",
          address2: formData.addressLine2 || "",
          city: formData.city || "",
          cityFromDropDown: false,
          state: formData.state || "",
          zip: formData.zipCode || "",
        },
        companyName: brokerageName || "",
        emailId: formData.emailId || "",
        firstName: formData.firstName || "",
        lastName: formData.lastName || "",
        brokerTitle: formData.brokerTitle || null,
        phoneNumber: formData.phoneNumber || "",
        websiteUrl: formData.websiteUrl || "",
        linkedInUrl: formData.linkedinUrl || null,
        agentBio: null,
        photoPath: formData.profilePhoto || "",
        logoPath: formData.logo || "",
        smsOptInStatus:
          formData.smsOptInStatus === "Yes"
            ? "Y"
            : formData.smsOptInStatus === "No"
            ? "N"
            : null,
        userId: formData.userId || "",
        userRoles: [formData.role || "AGENT"],
        brokerAffiliateAgent: isBrokerAffiliate,
        brokerAffiliateId: isBrokerAffiliate
          ? selectedBrokerageAffiliateId
          : null,
        brokerAffiliateName: isBrokerAffiliate
          ? selectedBrokerageAffiliateName
          : null,
      };

      const response = await saveUserDetails(bioPayload);
      if (response?.status === "SUCCESS") {
        setFormData((prev) => ({ ...prev, bio: "" }));
        toast.success("Bio deleted successfully");
      } else {
        toast.error("Failed to delete bio. Please try again.");
        throw new Error("Delete failed");
      }
    } catch (error) {
      toast.error("Failed to delete bio. Please try again.");
      throw error;
    } finally {
      setIsBioSaving(false);
    }
  };

  const handlePhotoUpload = async (file, isLogo) => {
    if (!file || !(file instanceof File)) {
      toast.error("Please select a valid file");
      return;
    }

    const userId = userProfileData?.userId;
    if (!userId) {
      toast.error("User ID not found");
      return;
    }

    try {
      const uploadFormData = new FormData();
      uploadFormData.append("file", file, file.name);
      uploadFormData.append("userId", String(userId));
      uploadFormData.append("fileType", isLogo ? "LOGO" : "PHOTO");

      const response = await uploadProfilePhoto(uploadFormData);
      if (response?.status === "SUCCESS") {
        const imageUrl = response.data;
        if (isLogo) {
          setFormData((prev) => ({
            ...prev,
            logo: imageUrl,
            logoPath: imageUrl,
          }));
        } else {
          setFormData((prev) => ({
            ...prev,
            profilePhoto: imageUrl,
            photoPath: imageUrl,
          }));
        }
        // Update profile photo URL immediately
        if (imageUrl && userProfileData?.userId) {
          const newUrl = await getProfilePhotoUrl(userProfileData.userId, imageUrl);
          if (isLogo) {
            setLogoUrl(newUrl);
          } else {
            setProfilePhotoUrl(newUrl);
          }
        }
        setHasUnsavedChanges(true);
        toast.success(`${isLogo ? "Logo" : "Photo"} uploaded successfully`);
      } else {
        throw response;
      }
    } catch (error) {
      toast.error(error.response?.data?.message || error?.message || error?.errorMessage || "Failed to upload Photo.");
    }
  };

  const handleLogoRemove = async () => {
    try {
      const response = await removeProfilePhoto();
      if (response?.status === "SUCCESS") {
        setFormData((prev) => ({
          ...prev,
          logo: "",
          logoPath: "",
        }));
        setHasUnsavedChanges(true);
      } else {
        throw new Error(response?.message || "Remove failed");
      }
    } catch (error) {
      console.error("Logo remove error:", error);
      throw error;
    }
  };

  const resetAllState = () => {
    setShouldRefresh(false);
    setFormData({
      firstName: "",
      lastName: "",
      brokerTitle: "",
      emailId: "",
      userId: "",
      phoneNumber: "",
      companyName: "",
      websiteUrl: "",
      linkedinUrl: "",
      bio: "",
      photoPath: "",
      logoPath: "",
      address: {
        address1: "",
        address2: "",
        city: "",
        cityFromDropDown: false,
        state: "",
        zip: "",
      },
      userRoles: [],
      smsOptInStatus: null,
    });
    setErrors({});
    setLicenseDetails({
      licenseNumber: "",
      state: "",
    });
    setLicenses([]);
    setAgentLicenseInfo([]);
    setAgentCorpLicenseInfo([]);
    setCities([]);
    setLicenseData(null);
    setInitialValues(null);
    setInitialCorpValues(null);
    setSelectedLicense({
      agentLicenseAddress1: "",
      agentLicenseAddress2: "",
      agentLicenseCity: "",
      agentLicenseZip: "",
      affiliatedCompany: "",
      licenseNumber: "",
      stateId: "",
      agentLicenseState: "",
      licenceExpiryDate: "",
      cityFromDropDown: false,
    });
    setLicenseType("Indv");
    setErrorSubmitting("");
    setShowLicenseModal(false);
    setIdologyVerified(false);
    setModalMode("");
    setLicenseData(null);
    setLicenseErrMsg("");
  };

  const handleCorpLicenseFormSubmit = async (licenseData) => {
    try {
      if (modalMode == "Add") {
        setInitialCorpValues(null);
        setLicenseLoading(true);
        const data = await verifyLicenseDetails(
          licenseData?.licenceNumber,
          licenseData?.stateId
        );
        if (
          data?.verificationStatus === "LICENSE_FORMAT_NOT_OK" &&
          data?.inputStateId == "AL"
        ) {
          setErrorSubmitting(data?.licenseFormatDescription);
          setLicenseLoading(false);
        } else {
          setErrorSubmitting("");
          const response = await insertCorporateLicence(licenseData);
          if (response?.data?.status === "SUCCESS") {
            trackButtonClick({
              eventName: "add_license_button_click_success",
              eventCategory: "Profile Forms My Shopper",
              eventSource: "on add license success - corp",
              eventLabel: "Agent",
            });

            const allLicense = await getAllLicenseDetails();
            setAgentCorpLicenseInfo(allLicense?.response?.CORP || []);
            toast.success("License Added successfully", {
              closeOnClick: true,
              autoClose: 5000,
            });
            setShowModal(false);
            setLicenseLoading(false);
          } else {
            if (
              response?.data?.errorMessage === "VALIDATION_STATE_ZIP_FAILURE"
            ) {
              trackApiCall({
                eventName: "add_license_button_click_failure",
                eventCategory: `Error - License Update My Shopper - VALIDATION_STATE_ZIP_FAILURE`,
                eventSource: "on add license failure",
                eventLabel: "Agent",
              });
              setErrorSubmitting(
                "Provided zip code is not valid for selected state"
              );
            } else if (
              response?.data?.errorMessage === "STATE_LICENSE_ALREADY_EXIST"
            ) {
              setErrorSubmitting(
                "A Corp License already exists for that state. You are allowed to only one Corp License for a State"
              );
            } else {
              toast.error(response?.data?.errorMessage);
            }
          }
        }
      } else {
        setInitialCorpValues(null);
        setLicenseLoading(true);
        const data = await verifyLicenseDetails(
          licenseData?.licenceNumber,
          licenseData?.stateId
        );
        if (
          data?.verificationStatus === "LICENSE_FORMAT_NOT_OK" &&
          data?.inputStateId == "AL"
        ) {
          setErrorSubmitting(data?.licenseFormatDescription);
          setLicenseLoading(false);
        } else {
          setErrorSubmitting("");
          const response = await updateCorporateLicence(licenseData);
          if (response?.data?.status === "SUCCESS") {
            trackApiCall({
              eventName: "update_button_click_success",
              eventCategory: "Profile Forms My Shopper",
              eventSource: "on update license success",
              eventLabel: "Agent",
            });

            const allLicense = await getAllLicenseDetails();
            setAgentCorpLicenseInfo(allLicense?.response?.CORP || []);
            toast.success("License details successfully updated", {
              closeOnClick: true,
              autoClose: 5000,
            });
            setShowModal(false);
            setLicenseLoading(false);
          } else {
            if (
              response?.data?.errorMessage === "VALIDATION_STATE_ZIP_FAILURE"
            ) {
              trackApiCall({
                eventName: "update_button_click_failure",
                eventCategory: `Error - License update My Shopper - VALIDATION_STATE_ZIP_FAILURE`,
                eventSource: "on update license failure",
                eventLabel: "Agent",
              });
              setErrorSubmitting(
                "Provided zip code is not valid for selected state"
              );
            } else if (
              response?.data?.errorMessage === "STATE_LICENSE_ALREADY_EXIST"
            ) {
              setErrorSubmitting(
                "A Corp License already exists for that state. You are allowed to only one Corp License for a State"
              );
            } else {
              toast.error(response?.data?.errorMessage);
            }
          }
        }
      }
    } catch (error) {
      console.error("Error in handleCorpLicenseFormSubmit:", error);
      toast.error("An unexpected error occurred. Please try again.");
    } finally {
      setLicenseLoading(false);
    }
  };

  //submit (add/update license)
  const handleLicenseFormSubmit = async (licenseData) => {
    try {
      setLicenseErrMsg("");
      if (modalMode == "Add") {
        setLicenseLoading(true);
        setInitialValues(null);
        const data = await verifyLicenseDetails(
          licenseData?.licenceNumber,
          licenseData?.stateId
        );
        if (data?.verificationStatus === "LICENSE_FORMAT_NOT_OK") {
          let agentStateError = AgentLiecenseErrorMsgs[data?.jurisdictName];
          if (agentStateError !== "No license format information") {
            setErrorSubmitting(agentStateError);
            setShowModal(true);
          }
          setLicenseLoading(false);
        } else {
          setErrorSubmitting("");
          const response = await insertUserLicense(licenseData);
          if (
            response?.status === "SUCCESS" &&
            (response?.license_status === "LCNS_APRD" ||
              response?.license_status === "LCNS_PEND")
          ) {
            trackButtonClick({
              eventName: "add_license_button_click_success",
              eventCategory: "Profile Forms My Shopper",
              eventSource: "on add license success",
              eventLabel: "Agent",
            });

            const allLicense = await getAllLicenseDetails();
            setAgentLicenseInfo(allLicense?.response?.INDV || []);
            if (response?.license_status === "LCNS_APRD") {
              toast.success("License Added successfully", {
                closeOnClick: true,
                autoClose: 5000,
              });
            } else {
              toast.error(
                "License update pending. Please check data in Arello.",
                {
                  closeOnClick: true,
                  autoClose: 5000,
                }
              );
            }
            setShowModal(false);
            setLicenseLoading(false);
          } else if (response?.status === "SUCCESS") {
            const statusMessages = {
              //"LCNS_PEND": "License update pending. Please check data in Arello.",
              LCNS_RJCT: "License update pending. Please check data in Arello.",
              LCNS_SUSP:
                "License update pending. Please contact Hubzu customer care.",
            };
            toast.error(
              statusMessages[response?.license_status] ||
                "License processing failed"
            );
            setShowModal(false);
            setLicenseLoading(false);
          } else {
            if (response?.ERROR === "VALIDATION_STATE_ZIP_FAILURE") {
              trackApiCall({
                eventName: "add_license_button_click_failure",
                eventCategory: `Error - License add My Shopper - VALIDATION_STATE_ZIP_FAILURE`,
                eventSource: "on add license failure",
                eventLabel: "Agent",
              });
              setErrorSubmitting(
                "Provided zip code is not valid for selected state"
              );
            } else {
              toast.error(response?.ERROR);
              setShowModal(false);
            }
          }
        }
      } else {
        setInitialValues(null);
        setLicenseLoading(true);
        const data = await verifyLicenseDetails(
          licenseData?.licenceNumber,
          licenseData?.stateId
        );
        if (data?.verificationStatus === "LICENSE_FORMAT_NOT_OK") {
          let agentStateError = AgentLiecenseErrorMsgs[data?.jurisdictName];
          if (agentStateError !== "No license format information") {
            setErrorSubmitting(agentStateError);
            setShowModal(true);
          }
          setLicenseLoading(false);
        } else {
          setErrorSubmitting("");
          const response = await updateUserLicense(licenseData);
          if (
            response?.status === "SUCCESS" &&
            (response?.license_status === "LCNS_APRD" ||
              response?.license_status === "LCNS_PEND")
          ) {
            trackApiCall({
              eventName: "update_button_click_success",
              eventCategory: "Profile Forms My Shopper",
              eventSource: "on update license success",
              eventLabel: "Agent",
            });

            const allLicense = await getAllLicenseDetails();
            setAgentLicenseInfo(allLicense?.response?.INDV || []);
            if (response?.license_status === "LCNS_APRD") {
              toast.success("License details successfully updated", {
                closeOnClick: true,
                autoClose: 5000,
              });
            } else {
              toast.error(
                "License update pending. Please check data in Arello.",
                {
                  closeOnClick: true,
                  autoClose: 5000,
                }
              );
            }
            setLicenseLoading(false);
            setShowModal(false);
          } else if (response?.status === "SUCCESS") {
            const statusMessages = {
              //"LCNS_PEND": "License update pending. Please check data in Arello.",
              LCNS_RJCT: "License update pending. Please check data in Arello.",
              LCNS_SUSP:
                "License update pending. Please contact Hubzu customer care.",
            };
            toast.error(
              statusMessages[response?.license_status] ||
                "License processing failed"
            );
            setLicenseLoading(false);
            setShowModal(false);
          } else {
            if (response?.ERROR === "VALIDATION_STATE_ZIP_FAILURE") {
              trackApiCall({
                eventName: "update_button_click_failure",
                eventCategory: `Error - License Update My Shopper - VALIDATION_STATE_ZIP_FAILURE`,
                eventSource: "on update license failure",
                eventLabel: "Agent",
              });
              setErrorSubmitting(
                "Provided zip code is not valid for selected state"
              );
            } else {
              toast.error(response?.ERROR);
              setShowModal(false);
            }
          }
        }
      }
    } catch (error) {
      toast.error("Failed to update license");
      throw error; // This will be caught by the modal's error handling
    } finally {
      setLicenseLoading(false);
    }
  };

  const handleDeleteLicense = async (licenseId) => {
    trackButtonClick({
      eventName: "delete_button_click",
      eventCategory: "Profile FormsMy Shopper",
      eventSource: "on delete icon click",
      eventLabel: licenseId + "|Agent",
    });

    try {
      const response = await deleteLicense(licenseId);

      if (response?.status === "SUCCESS") {
        trackApiCall({
          eventName: "delete_button_click_success",
          eventCategory: "Profile FormsMy Shopper",
          eventSource: "on delete icon click",
          eventLabel: licenseId + "|Agent",
        });
        toast.success("License deleted successfully", { autoClose: 5000 });
        const allLicense = await getAllLicenseDetails();
        setAgentLicenseInfo(allLicense?.response?.INDV || []);
      } else {
        toast.error(response?.ERROR || "Unable to delete, Please try again");
      }
    } catch (error) {
      toast.error("Failed to delete license");
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteCorpLicense = async (licenseId) => {
    trackButtonClick({
      eventName: "delete_button_click",
      eventCategory: "Profile FormsMy Shopper",
      eventSource: "on delete icon click",
      eventLabel: licenseId + "|Agent",
    });

    try {
      const response = await deleteCorporateLicence(licenseId);

      if (response?.data?.status === "SUCCESS") {
        trackApiCall({
          eventName: "delete_button_click_success",
          eventCategory: "Profile FormsMy Shopper",
          eventSource: "on delete icon click",
          eventLabel: licenseId + "|Agent",
        });
        toast.success("License deleted successfully", { autoClose: 5000 });
        const allLicense = await getAllLicenseDetails();
        setAgentCorpLicenseInfo(allLicense?.response?.CORP || []);
      } else {
        toast.error(
          response?.data?.errorMessage || "Unable to delete, Please try again"
        );
      }
    } catch (error) {
      toast.error("Failed to delete license");
    } finally {
      setIsLoading(false);
    }
  };

  const handleEmailChange = async (payload) => {
    trackButtonClick({
      eventName: "update_email_click",
      eventCategory: "My Profile My Shopper",
    });

    const email = payload.newEmail;
    try {
      // Show loading state if needed
      setLoading(true);
      setEmailVerificationError(null);

      // Check if email belongs to a deleted user
      const encodedEmail = encodeURIComponent(email);
      const queryString = `emailId=${encodedEmail}`;
      const deletedUserCheck = await checkDeletedUserEmail(queryString);

      if (
        deletedUserCheck?.data?.status === "SUCCESS" &&
        deletedUserCheck?.data?.data === true
      ) {
        setEmailVerificationError(
          "The account associated with the given email address is marked for deletion. Please provide a different email address."
        );
        return { success: false, message: "Email belongs to a deleted user" };
      }

      // Validate email change
      const emailValidation = await validateChangeEmail({
        newEmail: email,
      });

      if (emailValidation?.data?.status !== "SUCCESS") {
        const errorCode =
          emailValidation.data.errorCode || emailValidation.data.errorMessage;

        trackApiCall({
          eventName: "update_email_error",
          eventCategory: "My Profile My Shopper",
          eventLabel: errorCode,
        });

        switch (errorCode) {
          case "ACCOUNT_FOR_PROVIDED_EMAIL_ALREADY_EXIST":
            setEmailVerificationError(
              "An account with this email address already exists."
            );
            break;
          case "EMAIL_ALREADY_ASSOCIATED_TO_LOGGEDIN_USER":
            setEmailVerificationError("Email address already associated.");
            break;
          case "INVALID_USER_ACCOUNT_STATUS":
            setEmailVerificationError(
              "The account associated with this email address has been locked. Please call Customer Care at (855) 882-1314."
            );
            break;
          default:
            setEmailVerificationError("Invalid email or email cannot be used");
        }

        return { success: false, message: "Email validation failed" };
      }

      // Check if email is already verified
      const emailVerification = await isUserEmailVerified(email);

      if (emailVerification?.data?.status !== "SUCCESS") {
        trackApiCall({
          eventName: "update_email_error",
          eventCategory: "My Profile My Shopper",
          eventLabel: "Email already verified",
        });

        setEmailVerificationError(
          "This email is already verified with another account"
        );
        return { success: false, message: "Email already verified" };
      } else if (
        emailVerification?.data?.status === "SUCCESS" &&
        emailVerification?.data?.data
      ) {
        trackApiCall({
          eventName: "email_validation_popup_open_error",
          eventCategory: "My Profile",
          eventLabel: "Email already verified",
        });

        setEmailVerificationError(
          "This email is already verified with another account."
        );
        return {
          success: false,
          message: "Email already verified",
        };
      }

      // Send verification code
      const verificationCodeResponse = await sendVerificationCode({
        verificationCodeSentTo: email,
        verificationType: "EMAIL",
      });

      if (verificationCodeResponse?.data?.status === "SUCCESS") {
        trackApiCall({
          eventName: "email_validation_popup_open",
          eventCategory: "My Profile",
          eventLabel: "Verification code sent successfully",
        });

        setEmailVerification(true);
        return {
          success: true,
          message: "Verification code sent successfully",
        };
      }

      if (
        verificationCodeResponse?.data?.status === "FAILURE" &&
        verificationCodeResponse?.data?.errorCode ===
          "VERIFICATION_CODE_LIMIT_EXEEDED"
      ) {
        trackApiCall({
          eventName: "email_validation_popup_open_error",
          eventCategory: "My Profile",
          eventLabel: "Verification code limit exceeded",
        });

        setEmailVerificationError(
          "You've exceeded number of attempts, please try again after some time."
        );
        return {
          success: false,
          message: "Verification code limit exceeded",
        };
      }

      // Handle other verification code response errors
      setEmailVerificationError(
        "Failed to send verification code. Please try again."
      );
      return {
        success: false,
        message: "Failed to send verification code",
      };

      // if (!deletedUserCheck?.data?.data) {
      //   // Second API call - only proceed if first call was successful
      //   const emailValidation = await validateChangeEmail({
      //     newEmail: payload.newEmail,
      //   });
      //   if (emailValidation?.data?.data) {
      //     // Third API call
      //     const emailVerification = await isUserEmailVerified(email);
      //     if (!emailVerification?.data?.data) {
      //       // Fourth API call
      //       const verificationCodeResponse = await sendVerificationCode({
      //         verificationCodeSentTo: email,
      //         verificationType: "EMAIL",
      //       });
      //       if (verificationCodeResponse?.data?.status === "SUCCESS") {
      //         setEmailVerification(true);
      //       } else {
      //         if (
      //           verificationCodeResponse?.data?.errorCode ===
      //           "VERIFICATION_CODE_LIMIT_EXEEDED"
      //         ) {
      //           setEmailVerificationError(
      //             "You've exceeded number of attempts, please try again after some time."
      //           );
      //         }
      //       }
      //     }
      //   }
      // }

      // // If all calls are successful
      // setLoading(false);
      // // Handle success (e.g., show success message, update UI)
      // // Handle success
      // return {
      //   success: true,
      //   message: "Email change process completed successfully",
      // };
    } catch (error) {
      console.error("Error in email change process:", error);
      setEmailVerificationError("An error occurred. Please try again later.");
      return {
        success: false,
        message: error.message || "Unknown error occurred",
      };
    } finally {
      setLoading(false);
    }
  };

  const handlePasswordSet = async (payload) => {
    const password = payload.password;

    try {
      // Show loading state if needed
      setLoading(true);
      const requestId = generateRandomID();
      await getRequestId({ requestId: requestId });

      const [encryptedNewPassword] = await Promise.all([encrypt(password)]);

      const payload = {
        cryptoAlgVersion: "V3",
        newPassword: encryptedNewPassword,
        oldPassword: "",
        requestId: requestId,
      };

      const response = await changePassword(payload);
      if (response?.SUCCESS) {
        trackApiCall({
          eventName: "change_password_success",
          eventCategory: "My Profile",
          eventSource: "my profile change password success",
        });

        toast.success("Password changed successfully");
        // Handle JWT token update if needed
        if (response.jwtDetailsDto) {
          // Update tokens in your auth context/store
        }
        handlePasswordModalClose();
        setResetPasswordModalState(true);
        userSignOut({ isLoginModalRequired: true });
      } else {
        trackApiCall({
          eventName: "change_password_error",
          eventCategory: "My Profile",
          eventSource: `Error - ${response?.ERROR}`,
        });

        toast.error(
          response?.ERROR || "Something went wrong, Please try again later"
        );
      }
    } catch (error) {
      toast.error("Failed to set password");
      setResetPasswordModalState(false);
      console.error("Error in setting the process:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleEmailModalOpen = (e) => {
    e.preventDefault();
    setShowEmailModal(true);

    trackButtonClick({
      eventName: "change_email_click",
      eventCategory: "My Profile My Shopper",
    });
  };

  const handleEmailModalClose = () => {
    setShowEmailModal(false);

    trackButtonClick({
      eventName: "cancel_update_email_click",
      eventCategory: "My Profile My Shopper",
    });
  };

  const handlePasswordModalOpen = () => {
    // setShowPasswordModal(true);

    trackButtonClick({
      eventName: "change_password_click",
      eventCategory: "My Profile My Shopper",
    });
    navigate("/my-shopper/accountSettings", {
      state: { focusPasswordField: true },
    });
  };

  const handlePasswordModalClose = () => {
    setShowPasswordModal(false);

    trackButtonClick({
      eventName: "cancel_change_password_click",
      eventCategory: "My Profile My Shopper",
    });
  };

  const handleStateChange = async (e) => {
    const stateCode = e.target.value;

    setFormData((prev) => ({
      ...prev,
      state: stateCode,
      city: "", // Reset city when state changes
    }));

    if (stateCode) {
      try {
        const response = await getCitiesByState(stateCode);

        if (response?.status === "SUCCESS" && Array.isArray(response.data)) {
          // Convert string array to array of objects with value and label
          // const formattedCities = response.data.map((cityName) => ({
          //   value: cityName,
          //   label: cityName,
          // }));
          const cityArray = response.data || response;
          setCities(Array.isArray(cityArray) ? cityArray : []);

          // setCities(formattedCities);
        }
      } catch (error) {
        setCities([]);
      }
    } else {
      setCities([]);
    }
  };

  // Function to handle edit form modal
  const handleEditClick = async (rowData) => {
    setLicenseType("Indv");
    const license = rowData.licenceId || rowData?.agentLicenseId;

    trackButtonClick({
      eventName: "edit_link_click",
      eventCategory: "Profile Forms My Shopper",
      eventSource: "on edit icon click",
      eventLabel: license + "|Agent|addLicense",
    });

    await getLicenseDetails(license);
    setInitialValues({
      licenseNumber: rowData.licenseNumber,
      stateId: rowData?.stateId || rowData?.stateDto?.stateId,
      agentLicenseAddress1: rowData.address1,
      agentLicenseAddress2: rowData.address2,
      agentLicenseCity: rowData.city,
      agentLicenseZip: rowData.zip,
      affiliatedCompany: rowData.afftCompanyName || rowData?.company,
      agentLicenseState: rowData.agentLicenseState || rowData?.state,
      licenseExpiryDate: rowData.expiryDate
        ? formatDisplayDate(rowData.expiryDate)
        : formatDisplayDate(rowData.licenseExpiryDate),
      cityFromDropDown: rowData.cityFromDropDown || false,
      licenceId: rowData.licenseId || rowData?.agentLicenseId,
    });
    setModalMode("edit");
    setShowModal(true);
    setLicenseLoading(false);
  };

  const handleEditCorpClick = async (rowData, type) => {
    setLicenseType("Corp");
    const id = rowData.licenseId || rowData.agentLicenseId;

    trackButtonClick({
      eventName: "edit_link_click",
      eventCategory: "Profile Forms My Shopper",
      eventSource: "on edit icon click",
      eventLabel: id + "|Agent|addLicense",
    });

    const data = await editCorporateDetail(id);
    setInitialCorpValues({
      licenseNumber: data?.data?.data?.licenseNumber,
      stateId: data?.data?.data?.stateId,
      agentLicenseAddress1: data?.data?.data?.address1,
      agentLicenseAddress2: data?.data?.data?.address2,
      agentLicenseCity: data?.data?.data?.city,
      agentLicenseZip: data?.data?.data?.zip,
      affiliatedCompany: data?.data?.data?.company,
      agentLicenseState: data?.data?.data?.state,
      licenseExpiryDate: data?.data?.data?.expiryDate
        ? formatDisplayDate(data?.data?.data?.expiryDate)
        : "",
      cityFromDropDown: rowData?.cityFromDropDown || false,
      licenceId: id,
    });
    setModalMode("edit");
    setShowModal(true);
    setLicenseLoading(false);
  };

  const openAddLicenseModal = (type) => {
    trackButtonClick({
      eventName: "add_license_button_click",
      eventParams: { license_type: type },
      eventCategory: "Profile Forms My Shopper",
      eventSource: type - "on add license click",
      eventLabel: "Agent|addLicense",
    });

    if (type === "Corp") {
      setLicenseType("Corp");
      setLicenseLoading(false);
      setInitialCorpValues({
        licenseNumber: "",
        stateId: "",
        agentLicenseAddress1: "",
        agentLicenseAddress2: "",
        agentLicenseCity: "",
        agentLicenseZip: "",
        affiliatedCompany: "",
        agentLicenseState: "",
        licenseExpiryDate: "",
        cityFromDropDown: "",
        primaryAgentLicenceId: "",
      });
    } else {
      setLicenseType("Indv");
      setLicenseLoading(false);
      setInitialValues({
        licenseNumber: "",
        stateId: "",
        agentLicenseAddress1: "",
        agentLicenseAddress2: "",
        agentLicenseCity: "",
        agentLicenseZip: "",
        affiliatedCompany: "",
        agentLicenseState: "",
        licenseExpiryDate: "",
        cityFromDropDown: "",
        primaryAgentLicenceId: "",
      });
    }
    setShowModal(true);
    setModalMode("Add");
  };

  const onSubmit = async (data) => {
    try {
      setIsLoading(true);

      const response = await saveUserDetails(data);

      if (!response) {
        throw new Error("No response received");
      }

      switch (response.status) {
        case "SUCCESS":
          window.scrollTo(0, 0);
          toast.success("Profile completed");
          setHasUnsavedChanges(false);

          trackApiCall({
            eventName: "profile_update_success",
            eventCategory: "Profile UpdateMy Shopper",
            eventLabel: userType,
            isBrokerAffiliate: isBrokerAffiliate ? "Yes" : "No"
          });

          try {
            const userProfile = await getUserProfile();
            if (!userProfile?.data?.userDetails) {
              throw new Error("User profile data not found");
            }
            setUserProfileData(userProfile.data.userDetails);
            // check for deleted user api calls if idology is not verified
            const isIdologyRequired =
              userProfile?.data?.userDetails?.idologyVerificationRequired;
            if (isIdologyRequired) {
              const encodedEmail = encodeURIComponent(formData?.emailId);
              const queryString = `emailId=${encodedEmail}`;
              const deletedUserCheck = await checkDeletedUserEmail(queryString);
              if (deletedUserCheck?.data?.status === "SUCCESS") {
                if (deletedUserCheck?.data?.data === true) {
                  toast.error(
                    "This email is associated with a deleted account. Please contact support for assistance."
                  );
                }
              }
            }
          } catch (error) {
            toast.error(error.message || "Failed to fetch user profile");
          }

          break;

        case "FAILURE":
          const errorMessage = response.errorMessage;
          trackApiCall({
            eventName: "profile_update_failure",
            eventCategory: `Error - Profile UpdateMy Shopper - ${errorMessage}`,
            eventLabel: userType,
          });

          if (
            errorMessage === "REGISTRATION_ZIP_FAILURE" ||
            errorMessage === "VALIDATION_STATE_ZIP_FAILURE"
          ) {
            setErrors({
              ...errors,
              zipCode: "Provided zip code is not valid for the state",
            });
            setTimeout(() => {
              formRefs?.current?.["zipCode"]?.focus();
            }, 100);
          } else if (errorMessage === "REGISTRATION_CITY_FAILURE") {
            setErrors({
              ...errors,
              city: "Provided city name is not valid for the state",
            });
            setTimeout(() => {
              formRefs?.current?.["city"]?.focus();
            }, 100);
          } else if (errorMessage.includes("Address")) {
            setErrors({
              ...errors,
              addressLine1: errorMessage,
            });
            setTimeout(() => {
              formRefs?.current?.["addressLine1"]?.focus();
            }, 100);
          } else if (errorMessage === "MISSING_LICENSE_ALERT") {
            setLicenseErrMsg("Please enter valid license details");
          } else if (errorMessage.includes("LinkedIn")) {
            const cleanMsg = errorMessage.replace(/[\[\]]/g, '');
            setErrors({
              ...errors,
              linkedinUrl: cleanMsg,
            });
            setTimeout(() => {
              formRefs?.current?.["linkedinUrl"]?.focus();
            }, 100);
          } else if (errorMessage.includes("Website") || errorMessage.includes("website")) {
            const cleanMsg = errorMessage.replace(/[\[\]]/g, '');
            setErrors({
              ...errors,
              websiteUrl: cleanMsg,
            });
            setTimeout(() => {
              formRefs?.current?.["websiteUrl"]?.focus();
            }, 100);
          } else if (errorMessage.includes("Title") || errorMessage.includes("title") || errorMessage.includes("brokerTitle")) {
            const cleanMsg = errorMessage.replace(/[\[\]]/g, '');
            setErrors({
              ...errors,
              brokerTitle: cleanMsg,
            });
            setTimeout(() => {
              formRefs?.current?.["brokerTitle"]?.focus();
            }, 100);
          } else if (errorMessage.includes("Bio") || errorMessage.includes("bio")) {
            const cleanMsg = errorMessage.replace(/[\[\]]/g, '');
            toast.error(cleanMsg);
          } else {
            const cleanMsg = errorMessage.replace(/[\[\]]/g, '');
            toast.error(cleanMsg);
          }

        // toast.error(errorMessage);
        // break;

        // default:
        //   toast.error("Unexpected response status");
      }
    } catch (error) {
      toast.error(error || "Failed to save user details");
      console.error("Save error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const deleteUserProfile = async () => {
    trackButtonClick({
      eventName: "delete_account_button_click",
      eventLabel: "Profile Forms My Shopper",
      eventSource: "on delete account click",
    });

    setLoading(true);
    try {
      //delete user API call
      const response = await deleteUser();

      if (response.status === "SUCCESS") {
        toast.success(
          "Account deleted successfully! Redirecting to Home Page..."
        );
        setShowConfirmation(false);

        trackApiCall({
          eventName: "delete_your_account_success",
          eventCategory: "Profile Forms My Shopper",
          eventSource: "On Delete account success",
        });

        setTimeout(() => {
          navigate("/");
          userSignOut({});
        }, 2000);
      } else if (response.status === "FAILURE") {
        trackApiCall({
          eventName: "delete_your_account_failure",
          eventCategory: "Profile Forms My Shopper",
          eventSource: "On Delete account failure",
        });

        if (response.errorMessage === "SESSION_REQUIRED") {
          toast.error("Session requried, Please login again");
          userSignOut({
            isLoginModalRequired: true,
          });
        } else {
          toast.error("Failed to complete action");
        }
      }
    } catch (error) {
      toast.error("Failed to complete action");
    } finally {
      setLoading(false);
    }
  };

  // Handle form submission
  const handleUserFormSubmit = async (event) => {
    event.preventDefault();
    const newErrors = {};
    let firstInvalidField = null;

    trackButtonClick({
      eventName: "profile_verification",
      eventCategory: "My Shopper",
    });

    // ✅ Validate only fields from formDetails, skip radio
    formDetails.forEach((field) => {
      const value = formData[field.name];
      if (field.required && (!value || value.trim() === "")) {
        if (!firstInvalidField) {
          firstInvalidField = field.name;
        }

        if (field.name === "addressLine1") {
          newErrors[field.name] = `Please enter a valid address.`;
        } else {
          newErrors[field.name] = `This field is required.`;
        }
      }
    });

    // handle validation for subscription option if user has not subscribed
    if (userProfileData?.smsOptInStatus == null && !formData.smsOptInStatus) {
      newErrors["smsOptInStatus"] = "Please select one option";
    }

    if (
      userType === "AGENT" &&
      isBrokerAffiliate &&
      !selectedBrokerageAffiliateName
    ) {
      newErrors["brokerAffiliateName"] =
        "Please select affiliate brokerage name";
      if (!firstInvalidField) {
        firstInvalidField = "brokerAffiliateName";
      }
    }

    if (userType === "AGENT" && formData.websiteUrl) {
      const urlRegex =
        /^^((https?|ftp|smtp):\/\/)?([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})(\/[^\s]*)?$/;
      if (!urlRegex.test(formData?.websiteUrl?.trim())) {
        newErrors["websiteUrl"] = "Invalid website URL";
      }
    }

    if (userType === "AGENT" && formData.linkedinUrl) {
      const urlRegex =
        /^^((https?|ftp|smtp):\/\/)?([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})(\/[^\s]*)?$/;
      if (formData.linkedinUrl.trim().length > 2048) {
        newErrors["linkedinUrl"] = "LinkedIn URL cannot exceed 2048 characters";
      } else if (!urlRegex.test(formData?.linkedinUrl?.trim())) {
        newErrors["linkedinUrl"] = "Invalid website URL";
      }
    }

    // If validation fails, set errors and stop
    if (
      Object.keys(newErrors).length > 0 ||
      Object.keys(errors).some((key) => errors[key])
    ) {
      setErrors((prev) => ({ ...prev, ...newErrors }));
      // Focus on the first field with an error
      const firstErrorField =
        firstInvalidField ||
        Object.keys(newErrors)[0] ||
        Object.keys(errors).find((key) => errors[key]);
      if (firstErrorField && formRefs?.current?.[firstErrorField]) {
        setTimeout(() => {
          formRefs.current[firstErrorField].focus();
        }, 100);
      }
      return;
    }

    try {
      setIsLoading(true);
      setUserSubmitForm(true);

      const isPhoneInUse = await isPhoneNoInUse(formData?.phoneNumber);
      if (isPhoneInUse.data.status === "SUCCESS" && isPhoneInUse.data.data) {
        setErrors({
          ...errors,
          phoneNumber:
            "This phone number is already verified for another user. Please use a different number",
        });
        formRefs?.current?.["phoneNumber"]?.focus();
        setUserSubmitForm(false);
        setIsLoading(false);
        return;
      }

      if (userType === "BUYR") {
        const payload = {
          agentDetails: null,
          userDetails: {
            address: {
              address1: formData.addressLine1 || "",
              address2: formData.addressLine2 || "",
              city: formData.city || "",
              cityFromDropDown: false,
              state: formData.state || "",
              zip: formData.zipCode || "",
            },
            companyName: "",
            emailId: formData.emailId || "",
            firstName: formData.firstName || "",
            lastName: formData.lastName || "",
            phoneNumber: formData.phoneNumber || "",
            websiteUrl: formData.websiteUrl || "",
            photoPath: formData.photoPath || "",
            logoPath: formData.logoPath || "",
            smsOptInStatus:
              formData.smsOptInStatus === "Yes"
                ? "Y"
                : formData.smsOptInStatus === "No"
                ? "N"
                : null,
            userId: formData.userId || "",
            userRoles: [formData.role || "BUYR"],
            brokerAffiliateAgent: false,
            brokerAffiliateId: null,
            brokerAffiliateName: null,
          },
        };

        const redisPayload = new FormData();
        redisPayload.append("emailId", formData?.emailId);

        const isBuyerProfileSaved = await saveBuyerProfile(payload);

        if (isBuyerProfileSaved?.status === "SUCCESS") {
          window.scrollTo(0, 0);
          toast.success("Profile completed");
          setHasUnsavedChanges(false);

          trackApiCall({
            eventName: "profile_update_success",
            eventCategory: "Profile UpdateMy Shopper",
            eventLabel: userType,
            isBrokerAffiliate: isBrokerAffiliate ? "Yes" : "No"
          });

          // await checkDeletedUserEmail(redisPayload);
          try {
            const userProfile = await getUserProfile();
            if (!userProfile?.data?.userDetails) {
              throw new Error("User profile data not found");
            }
            // check for deleted user api calls if idology is not verified
            const isIdologyRequired =
              userProfile?.data?.userDetails?.idologyVerificationRequired;
            if (isIdologyRequired) {
              const encodedEmail = encodeURIComponent(formData?.emailId);
              const queryString = `emailId=${encodedEmail}`;
              const deletedUserCheck = await checkDeletedUserEmail(queryString);
              if (deletedUserCheck?.data?.status === "SUCCESS") {
                if (deletedUserCheck?.data?.data === true) {
                  toast.error(
                    "This email is associated with a deleted account. Please contact support for assistance."
                  );
                }
              }
            }
            setUserProfileData(userProfile.data.userDetails);
          } catch (error) {
            toast.error(error.message || "Failed to fetch user profile");
          }
        } else {
          const errorMessage = isBuyerProfileSaved.errorMessage;
          trackApiCall({
            eventName: "profile_update_failure",
            eventCategory: `Error - Profile UpdateMy Shopper - ${errorMessage}`,
            eventLabel: userType,
          });

          if (
            errorMessage === "REGISTRATION_ZIP_FAILURE" ||
            errorMessage === "VALIDATION_STATE_ZIP_FAILURE"
          ) {
            setErrors({
              ...errors,
              zipCode: "Provided zip code is not valid for the state",
            });
            setTimeout(() => {
              formRefs?.current?.["zipCode"]?.focus();
            }, 100);
          } else if (errorMessage === "REGISTRATION_CITY_FAILURE") {
            setErrors({
              ...errors,
              city: "Provided city name is not valid for the state",
            });
            setTimeout(() => {
              formRefs?.current?.["city"]?.focus();
            }, 100);
          } else if (errorMessage.includes("Address")) {
            setErrors({
              ...errors,
              addressLine1: errorMessage,
            });
            setTimeout(() => {
              formRefs?.current?.["addressLine1"]?.focus();
            }, 100);
          } else {
            toast.error("Failed to save user details");
          }
        }
        setUserSubmitForm(false);
        setIsLoading(false);
      } else {
        const agentPayload = {
          address: {
            address1: formData.addressLine1 || "",
            address2: formData.addressLine2 || "",
            city: formData.city || "",
            cityFromDropDown: false,
            state: formData.state || "",
            zip: formData.zipCode || "",
          },
          companyName: brokerageName || "",
          emailId: formData.emailId || "",
          firstName: formData.firstName || "",
          lastName: formData.lastName || "",
          brokerTitle: formData.brokerTitle || null,
          phoneNumber: formData.phoneNumber || "",
          websiteUrl: formData.websiteUrl || "",
          linkedInUrl: formData.linkedinUrl || null,
          agentBio: formData.bio || null,
          photoPath: formData.profilePhoto || "",
          logoPath: formData.logo || "",
          smsOptInStatus:
            formData.smsOptInStatus === "Yes"
              ? "Y"
              : formData.smsOptInStatus === "No"
              ? "N"
              : null,
          userId: formData.userId || "",
          userRoles: [formData.role || "AGENT"],
          brokerAffiliateAgent: isBrokerAffiliate,
          brokerAffiliateId: isBrokerAffiliate
            ? selectedBrokerageAffiliateId
            : null,
          brokerAffiliateName: isBrokerAffiliate
            ? selectedBrokerageAffiliateName
            : null,
        };
        onSubmit(agentPayload);
      }
    } catch (e) {
      toast.error("Failed to save user details");
      trackApiCall({
        eventName: "profile_update_failure",
        eventCategory: `Error - Profile UpdateMy Shopper`,
        eventLabel: userType,
      });
      setUserSubmitForm(false);
      setIsLoading(false);
    }
  };

  // Update your radio button handler
  const handleRoleChange = async (e) => {
    const newRole = e.target.value;

    setHasUnsavedChanges(true);
    setLicenseErrMsg("");

    // update filled fields tracking
    setPreviouslyFilledFields((prev) =>
      prev ? `${prev}, userTypeRadio${userType}` : `userTypeRadio${userType}`
    );

    if (newRole === "AGENT") {
      await fetchLicenseDetails();
      await fetchBrokerAffiliateNames();

      if (userData?.user?.userRole === "AGENT") {
        setFormData((prev) => ({
          ...prev,
          role: "AGENT",
        }));
        setUserType("AGENT");

        trackApiCall({
          eventName: "account_info_update",
          eventCategory: "Profile-Forms My Shopper",
          eventLabel: `Field Name : userTypeRadioAgent | Event Number : ${
            filledFieldsCount || 1
          } | Previously filled Field Names : ${
            previouslyFilledFields || ""
          } | user Type:${newRole}| Action Type : new`,
        });
        setFilledFieldsCount((prev) => prev + 1);
      } else {
        setShowRoleTypeModal(true);
        setRoleMessage("Are you sure want to switch the role?");
      }
    } else {
      const data = await agentActiveBids();
      trackApiCall({
        eventName: "account_info_update",
        eventCategory: "Profile-Forms My Shopper",
        eventLabel: `Field Name : userTypeRadioBuyer | Event Number : ${
          filledFieldsCount || 1
        } | Previously filled Field Names : ${
          previouslyFilledFields || ""
        } | user Type:${newRole}| Action Type : new`,
      });
      setFilledFieldsCount((prev) => prev + 1);

      if (data?.isAgentHasBidsAndOffers === "Y") {
        toast.error(
          "You cannot change your role since you have active bids/offers."
        );
      } else {
        if (
          userData?.user?.userType === "BUYR" &&
          agentLicenseInfo?.length === 0
        ) {
          setFormData((prev) => ({
            ...prev,
            role: "BUYR",
          }));
          setUserType("BUYR");
        } else {
          setShowRoleTypeModal(true);
          setRoleMessage(
            "Are you sure want to switch your role? All your licenses will be deleted. Please confirm."
          );
        }
      }
    }
  };

  const handleDownlaod = async () => {
    try {
      await downloadInfo();
      trackApiCall({
        eventName: "download_your_information",
        eventCategory: "My Shopper",
        eventLabel: `${userType}`,
      });
    } catch (error) {
      console.error("Error while downloading");
    }
  };

  const handleChangeAgent = async () => {
    if (userType === "BUYR") {
      setFormData((prev) => ({
        ...prev,
        role: "AGENT",
      }));
      setShowLicenseTable(true);
      setUserType("AGENT");
      setShowRoleTypeModal(false);
    } else {
      setFormData((prev) => ({
        ...prev,
        role: "BUYR",
      }));
      setUserType("BUYR");
      setShowLicenseTable(false);
      setShowRoleTypeModal(false);
    }

    trackApiCall({
      eventName: "account_info_update",
      eventCategory: "Profile-Forms My Shopper",
      eventLabel: `Field Name : userTypeRadioBuyer | Event Number : ${
        filledFieldsCount || 1
      } | Previously filled Field Names : ${
        previouslyFilledFields || ""
      } | user Type:Agent| Action Type : new`,
    });
    setFilledFieldsCount((prev) => prev + 1);
  };

  const fetchLicenseDetails = async () => {
    try {
      const allLicense = await getAllLicenseDetails();
      setAgentLicenseInfo(allLicense?.response?.INDV || []);
      setAgentCorpLicenseInfo(allLicense?.response?.CORP || []);
      setShowLicenseTable(true);
    } catch (error) {
      toast.error("Unable to get the license details, Please try again");
    }
  };

  const handleFormFieldChange = async (e, item = {}) => {
    const { name, value } = e.target;
    const isBlurEvent = e.type === "blur";

    setHasUnsavedChanges(true);

    if (item.name === "state") {
      handleStateChange(e);
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "",
      }));
      return;
    }

    // Sanitize brokerTitle — only allow [a-zA-Z0-9-.'_,\s]
    let sanitizedValue = value;
    if (name === "brokerTitle") {
      sanitizedValue = value.replace(/[^a-zA-Z0-9\-.'_,\s]/g, '');
    }

    // Update form data immediately
    setFormData((prevData) => ({
      ...prevData,
      [name]: sanitizedValue,
    }));

    // Clear any existing timeout
    if (trackingTimeoutRef.current) {
      clearTimeout(trackingTimeoutRef.current);
    }

    // Set a new timeout for tracking
    trackingTimeoutRef.current = setTimeout(() => {
      trackApiCall({
        eventName: "account_info_update",
        eventCategory: "Profile-Forms My Shopper",
        eventLabel: `Field Name : ${name} | Event Number : ${
          filledFieldsCount || 1
        } | Previously filled Field Names : ${
          previouslyFilledFields || ""
        } | user Type:${userType}| Action Type : new`,
      });
      setFilledFieldsCount((prev) => prev + 1);

      // Update previously filled fields
      setPreviouslyFilledFields((prev) => (prev ? `${prev}, ${name}` : name));
    }, 1000);

    // Run validation
    const validationErrors = validateForm({ [name]: value }, [name]);

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: validationErrors[name] || "",
    }));

    // Special case: addressLine2 can be empty
    if (name === "addressLine2" && value.length === 0) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "",
      }));
    }

    // Special case: validate phoneNumber only on blur and length = 10
    if (isBlurEvent && name === "phoneNumber" && value.length === 10) {
      try {
        const isPhoneInUse = await isPhoneNoInUse(value);

        if (
          isPhoneInUse?.data?.status === "SUCCESS" &&
          isPhoneInUse.data.data
        ) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            phoneNumber:
              "This phone number is already verified for another user. Please use a different number",
          }));

          // Focus phone input after short delay
          setTimeout(() => {
            formRefs?.current?.phoneNumber?.focus?.();
          }, 100);
        }
      } catch (error) {
        console.error("Phone number validation failed:", error);
      }
    }
  };

  useEffect(() => {
    if (shouldFocusPhoneField) {
      formRefs.current["phoneNumber"]?.focus();
      // Add smooth scroll to the profile name field
      formRefs.current["phoneNumber"]?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [shouldFocusPhoneField, isProfileLoading]);

  // Load profile photo URL
  useEffect(() => {
    const loadProfilePhoto = async () => {
      if (formData.photoPath && userProfileData?.userId) {
        try {
          const url = await getProfilePhotoUrl(
            userProfileData.userId,
            formData.photoPath
          );
          setProfilePhotoUrl(url);
        } catch (error) {
          console.error("Error loading profile photo:", error);
          setProfilePhotoUrl(null);
        }
      } else {
        setProfilePhotoUrl(null);
      }
    };

    loadProfilePhoto();
  }, [formData.photoPath, userProfileData?.userId]);

  // Load logo URL
  useEffect(() => {
    const loadLogo = async () => {
      if (formData.logoPath && userProfileData?.userId) {
        try {
          const url = await getProfilePhotoUrl(
            userProfileData.userId,
            formData.logoPath
          );
          setLogoUrl(url);
        } catch (error) {
          console.error("Error loading logo:", error);
          setLogoUrl(null);
        }
      } else {
        setLogoUrl(null);
      }
    };

    loadLogo();
  }, [formData.logoPath, userProfileData?.userId]);

  useEffect(() => {
    const fecthData = async () => {
      const userProfile = await getUserProfile();
      const data = userProfile?.data;

      const userRoles = data?.userDetails?.userRoles || [];
      const usrType = userRoles.includes("AGENT")
        ? "AGENT"
        : userRoles.includes("BUYR")
        ? "BUYR"
        : userRoles[0] || "";

      setUserType(usrType);

      setBrokerageName(data?.companyProfileDto?.brokerageName || "");
      setOnlyAgentRole(userRoles.length === 1 && userRoles.includes("AGENT"));

      if (usrType === "AGENT") {
        await fetchBrokerAffiliateNames();
      }

      setUserProfileData(data?.userDetails);
      setUserProfileStatus(data?.userDetails?.status);
    };
    if (idolodySuccess) {
      fecthData();
    }
  }, [idolodySuccess]);

  useEffect(() => {
    resetAllState();
    let isMounted = true;

    //getExperiments("onLoad");

    const fetchData = async () => {
      setIsProfileLoading(true);
      try {
        const userProfile = await getUserProfile();

        dispatch(setProfileInfo(userProfile.data));
        dispatch(setUserDetailsSlices(userProfile?.data));

        if (!isMounted) return; // Prevent state updates if component is unmounted

        const data = userProfile?.data;

        setFormData((prevData) => ({
          ...prevData,
          firstName: data?.userDetails?.firstName || "",
          lastName: data?.userDetails?.lastName || "",
          brokerTitle: data?.userDetails?.brokerTitle || "",
          emailId: data?.userDetails?.emailId || "",
          userId: data?.userDetails?.userId || "",
          addressLine1: data?.userDetails?.address?.address1 || "",
          addressLine2: data?.userDetails?.address?.address2 || "",
          state: data?.userDetails?.address?.state || "",
          city: data?.userDetails?.address?.city || "",
          zipCode: data?.userDetails?.address?.zip || "",
          phoneNumber: data?.userDetails?.phoneNumber || "",
          websiteUrl: data?.userDetails?.websiteUrl || "",
          linkedinUrl: data?.userDetails?.linkedInUrl || "",
          bio: data?.userDetails?.agentBio || "",
          photoPath: data?.userDetails?.photoPath || "",
          logoPath: data?.userDetails?.logoPath || "",
          profilePhoto: data?.userDetails?.profilePhoto || "",
          logo: data?.userDetails?.logo || "",
          userRoles: data?.userDetails?.userRoles || [],
          smsOptInStatus: data?.userDetails?.smsOptInStatus,
          address: {
            address1: data?.userDetails?.address?.address1 || "",
            address2: data?.userDetails?.address?.address2 || "",
            city: data?.userDetails?.address?.city || "",
            cityFromDropDown: false,
            state: data?.userDetails?.address?.state,
            zip: data?.userDetails?.address?.zip,
          },
        }));

        const userRoles = data?.userDetails?.userRoles || [];
        const usrType = userRoles.includes("AGENT")
          ? "AGENT"
          : userRoles.includes("BUYR")
          ? "BUYR"
          : userRoles[0] || "";

        setUserType(usrType);

        setBrokerageName(data?.companyProfileDto?.brokerageName || "");
        setOnlyAgentRole(userRoles.length === 1 && userRoles.includes("AGENT"));

        if (usrType === "AGENT") {
          setIsBrokerAffiliate(
            data?.userDetails?.brokerAffiliateAgent || false
          );
          setSelectedBrokerageAffiliateName(
            data?.userDetails?.brokerAffiliateName || ""
          );
          setSelectedBrokerageAffiliateId(
            data?.userDetails?.brokerAffiliateId || ""
          );
          await fetchLicenseDetails();
          await fetchBrokerAffiliateNames();
        }

        setUserProfileData(data?.userDetails);
        setAgentLicenseInfo(data?.agentLicenseInfo);
        setUserProfileStatus(data?.userDetails?.status);
        setAgentCorpLicenseInfo(data?.agentCorpLicenseInfo);
        setUserRoles(data?.userDetails?.userRoles || []);

        setIsProfileLoading(false);

        await getUserRecentSearch();
        const redisPayload = new FormData();
        redisPayload.append("emailAddr", await encrypt(currentEmail));

        // await getLicenseAddressRequiredStateList()
        await getLocation();
        await getSavedSearchAndPropertyCount(currentEmail);
        // await getCityListForState(userData?.address?.state)

        if (data?.userDetails?.address?.state) {
          const citiesData = await getCitiesByState(
            data?.userDetails?.address?.state
          );

          const cityArray = citiesData.data || citiesData;

          setCities(Array.isArray(cityArray) ? cityArray : []);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsProfileLoading(false);
      }
    };

    fetchData();

    return () => {
      isMounted = false;
      // Cleanup blob URLs
      if (profilePhotoUrl && profilePhotoUrl.startsWith("blob:")) {
        URL.revokeObjectURL(profilePhotoUrl);
      }
      if (logoUrl && logoUrl.startsWith("blob:")) {
        URL.revokeObjectURL(logoUrl);
      }
    };
  }, [isUserLoggedIn === true, shouldRefresh === true]);

  useEffect(() => {
    const fetch = async () => {
      if (licenseCityDropDowm) {
        const citiesData = await getCitiesByState(licenseCityDropDowm);
        const cityArray = citiesData.data || citiesData;
        setCitiesForLiecnse(Array.isArray(cityArray) ? cityArray : []);
      }
    };
    fetch();
  }, [licenseCityDropDowm]);

  useEffect(() => {
    return () => {
      if (trackingTimeoutRef.current) {
        clearTimeout(trackingTimeoutRef.current);
      }
    };
  }, []);

  const formattedStateOptions = stateList?.map((state) => ({
    value: state,
    label: state,
  }));

  const formDetails = [
    {
      label: "First Name",
      type: "text",
      name: "firstName",
      placeholder: "First Name",
      required: true,
      editLink: false,
      maxLength: "40",
    },
    {
      label: "Last Name",
      type: "text",
      name: "lastName",
      placeholder: "Last Name",
      required: true,
      editLink: false,
      maxLength: "40",
    },
    {
      label: "Title",
      type: "text",
      name: "brokerTitle",
      placeholder: "Ex. Senior Broker, Associate Broker, Commercial Rep",
      required: false,
      editLink: false,
      maxLength: "100",
      agentOnly: true,
    },
    {
      label: "Email",
      type: "email",
      name: "emailId",
      placeholder: "Email",
      required: true,
      editLink: true,
    },
    {
      label: "Address Line1",
      name: "addressLine1",
      type: "text",
      placeholder: "Address Line1",
      required: true,
      editLink: false,
    },
    {
      label: "Address Line 2",
      name: "addressLine2",
      type: "text",
      placeholder: "Address Line 2",
      required: false,
      editLink: false,
    },
    {
      label: "State",
      type: "dropdown",
      name: "state",
      placeholder: "State",
      required: true,
      editLink: false,
      options: formattedStateOptions,
      inputwidth: true,
    },
    {
      label: "City",
      type: "text",
      name: "city",
      placeholder: "City",
      required: true,
      editLink: false,
      options: cities,
    },
    {
      label: "Zip Code",
      type: "number",
      name: "zipCode",
      placeholder: "Zip Code",
      required: true,
      editLink: false,
      inputwidth: true,
    },
    {
      label: "Mobile",
      type: "tel",
      name: "phoneNumber",
      placeholder: "Mobile",
      required: true,
      editLink: false,
      maxLength: "10",
      inputwidth: true,
    },
  ];

  const licenseFields = [
    {
      label: "Issued By",
      type: "text",
      name: "affiliatedCompany",
      required: true,
      placeholder: "Issued By",
    },
    {
      label: "License Number",
      type: "text",
      name: "licenseNumber",
      required: true,
      placeholder: "License Number",
      maxLength: 40,
    },
    {
      label: "State",
      type: "select",
      name: "stateId",
      required: true,
      options: stateList?.map((state) => ({
        value: state,
        label: state,
      })),
    },
    {
      label: "Expiry Date",
      type: "date",
      name: "licenseExpiryDate",
      required: true,
      // placeholder: "MM/DD/YYYY",
    },
    {
      label: "License State Office Address",
      type: "header", // This will be rendered as a subheading
      name: "addressHeader",
    },
    {
      label: "Address Line 1",
      type: "text",
      name: "agentLicenseAddress1",
      required: false,
      placeholder: "Address Line 1",
    },
    {
      label: "Address Line 2",
      type: "text",
      name: "agentLicenseAddress2",
      required: false,
      placeholder: "Address Line 2",
    },
    {
      label: "State",
      type: "select",
      name: "agentLicenseState",
      required: false,
      options: stateList?.map((state) => ({
        value: state,
        label: state,
      })),
    },
    {
      label: "City",
      type: "text",
      name: "agentLicenseCity",
      required: false,
      placeholder: "Enter City",
      options: cityForLiecense,
    },
    {
      label: "Zip Code",
      type: "text",
      name: "agentLicenseZip",
      required: false,
      placeholder: "Zip Code",
      pattern: "[0-9]{5}",
      maxLength: 5,
    },
  ];

  const preContent = userProfileData != null &&
    userProfileData?.status === "ACTIVE" &&
    userProfileData?.idologyVerificationRequired && (
      <div className="idology-container mb-3">
        <Modal.Header className="idology-header">
          <Modal.Title className="idology-header-title">
            Please verify your details
          </Modal.Title>
          <Button
            variant="warning"
            className="verifyIdologyBtn"
            onClick={() => {
              setShowIdologyModal(true);
              trackButtonClick({
                eventName: "idology_verify_click",
                eventCategory: "My Shopper",
              });
            }}
          >
            Verify Now
          </Button>
        </Modal.Header>
        <Modal.Body>
          <div className="idology-modal-body">
            <div className={`content-wrapper ${showMore ? "expanded" : ""}`}>
              <p
                className="idology-modal-body-para"
                style={{
                  whiteSpace: "normal",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxHeight: showMore ? "none" : "20px",
                  transition: "max-height 0.3s ease-in-out",
                }}
              >
                Please take a moment to verify your identity by entering your
                first name, last name, date of birth and the last 4 digits of
                your Social Security Number. Verifying your information keeps
                the Hubzu® marketplace safe and accessible for everyone.
                {showMore && (
                  <>
                    <br />
                    <br />
                    If you're a licensed real estate agent, we also need some
                    information about your company for authentication purposes.
                    This is a one-time verification of your information.
                  </>
                )}
              </p>
            </div>
            <button
              className="read-more-btn"
              onClick={() => setShowMore(!showMore)}
              aria-expanded={showMore}
            >
              {showMore ? "read less" : "read more"}
            </button>
          </div>
        </Modal.Body>
      </div>
    );

  return (
    <DashboardSectionWrapper
      title="Profile Information"
      showDownloadBtn
      preContent={preContent}
      handleDocDownload={handleDownlaod}
      userProfileStatus={userProfileStatus}
    >
      <div className="p-4">
        <div className="row">
          {/* {userProfileData != null &&
            userProfileData?.status === "ACTIVE" &&
            userProfileData?.idologyVerificationRequired && (
              <div className="idology-container mb-3">
                <Modal.Header className="idology-header">
                  <Modal.Title className="idology-header-title">
                    Please verify your details
                  </Modal.Title>
                  <Button
                    variant="warning"
                    className="verifyIdologyBtn"
                    onClick={() => {
                      setShowIdologyModal(true);
                      trackButtonClick({
                        eventName: "idology_verify_click",
                        eventCategory: "My Shopper",
                      });
                    }}
                  >
                    Verify Now
                  </Button>
                </Modal.Header>
                <Modal.Body>
                  <div className="idology-modal-body">
                    <div
                      className={`content-wrapper ${
                        showMore ? "expanded" : ""
                      }`}
                    >
                      <p
                        className="idology-modal-body-para"
                        style={{
                          whiteSpace: "normal",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxHeight: showMore ? "none" : "20px",
                          transition: "max-height 0.3s ease-in-out",
                        }}
                      >
                        Please take a moment to verify your identity by entering
                        your first name, last name, date of birth and the last 4
                        digits of your Social Security Number. Verifying your
                        information keeps the Hubzu® marketplace safe and
                        accessible for everyone.
                        {showMore && (
                          <>
                            <br />
                            <br />
                            If you're a licensed real estate agent, we also need
                            some information about your company for
                            authentication purposes. This is a one-time
                            verification of your information.
                          </>
                        )}
                      </p>
                    </div>
                    <button
                      className="read-more-btn"
                      onClick={() => setShowMore(!showMore)}
                      aria-expanded={showMore}
                    >
                      {showMore ? "read less" : "read more"}
                    </button>
                  </div>
                </Modal.Body>
              </div>
            )} */}

          <Container className="mobile-no-padding">
            <div className="row">
              <div
                className={
                  userProfileData?.listingAgent ? "col-md-8" : "col-md-12"
                }
              >
                <form>
                  {!onlyAgentRole && (
                    <InputField
                      label="I am a"
                      type="radio"
                      placeholder="Select a role"
                      width="75%"
                      required={true}
                      name="role"
                      selected={userType}
                      options={[
                        { value: "BUYR", label: "Buyer" },
                        { value: "AGENT", label: "Agent" },
                      ]}
                      onChange={handleRoleChange}
                    />
                  )}

                  {formDetails?.map((item, index) => {
                    if (item.agentOnly && userType !== "AGENT") return null;
                    return (
                      <div key={index}>
                        <InputField
                          key={index}
                          formRef={formRefs}
                          label={item.label}
                          inputwidth={item.inputwidth}
                          placeholder={item.placeholder}
                          type={item.type}
                          maxLength={item.maxLength ? item.maxLength : ""}
                          required={item.required}
                          width="75%"
                          className="mb-1"
                          error={errors[item.name]}
                          isEditButtonEnabled={item.editLink}
                          name={item.name}
                          options={item.options || []}
                          onEdit={handleEmailModalOpen}
                          isProfileLoading={isProfileLoading}
                          isSetPasswordEnabled={userProfileData?.isSocialSignIn}
                          onSetPasswordClick={handlePasswordModalOpen}
                          value={formData[item.name] || ""}
                          disabled={item.name === "emailId" ? true : false}
                          onChange={(e) => handleFormFieldChange(e, item)}
                          handleBlur={(e) => handleFormFieldChange(e, item)}
                        />

                        {userType == "AGENT" && item.name === "zipCode" && (
                          <InputField
                            formRef={formRefs}
                            label="Brokerage Name"
                            type="text"
                            name="brokerageName"
                            placeholder="Brokerage Name"
                            width="75%"
                            className="mb-1"
                            isProfileLoading={isProfileLoading}
                            value={brokerageName}
                            onChange={(e) => {
                              setBrokerageName(e.target.value);
                              setHasUnsavedChanges(true);
                              setErrors((prev) => ({
                                ...prev,
                                brokerageName: "",
                              }));
                            }}
                          />
                        )}
                      </div>
                    );
                  })}
                  {userProfileData &&
                    userProfileData?.smsOptInStatus == null &&
                    formData?.state && (
                      <div>
                        <div className="profile-subscription">
                          <InputField
                            label={`Subscribe for text messages / alerts`}
                            lableStyle={{
                              paddingRight: "2rem",
                            }}
                            type={"dropdown"}
                            placeholder={"Select"}
                            required={true}
                            width="75%"
                            error={errors["smsOptInStatus"]}
                            name={"smsOptInStatus"}
                            options={["Yes", "No"]}
                            isProfileLoading={isProfileLoading}
                            value={formData.smsOptInStatus}
                            onChange={(e) => {
                              const { name, value } = e.target;
                              setHasUnsavedChanges(true);
                              setFormData((prevData) => ({
                                ...prevData,
                                [name]: value,
                              }));

                              setErrors((prevErrors) => ({
                                ...prevErrors,
                                [name]: "",
                              }));
                            }}
                          />
                          <p className="profile-subscription-para">
                            Do you want to receive important text message
                            notifications related to your bids?
                          </p>
                        </div>
                        {formData.smsOptInStatus === "Yes" && (
                          <p className="profile-subscription-subpara">
                            I agree to be contacted according to these{" "}
                            <span style={{ position: "relative", zIndex: 10 }}>
                              <a
                                href="/about/terms"
                                rel="noopener noreferrer"
                                target="_blank"
                                style={{
                                  color: "#0082f4",
                                  cursor: "pointer",
                                  textDecoration: "underline",
                                  position: "relative",
                                  zIndex: 10,
                                  display: "inline-block",
                                  padding: "0 2px",
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  window.open("/about/terms", "_blank");
                                }}
                              >
                                Terms & Conditions.
                              </a>
                            </span>{" "}
                            This consent includes receiving autodialed calls and
                            texts from Altisource Online Auction, Inc. and its
                            affiliates. I understand that this consent is not a
                            condition to receiving any services.
                          </p>
                        )}
                      </div>
                    )}

                  {userType == "AGENT" && (
                    <>
                      <InputField
                        formRef={formRefs}
                        label="Are you an active Hubzu Broker Affiliate?"
                        type="checkbox"
                        name="isBrokerAffiliate"
                        width="75%"
                        className="mb-1"
                        isProfileLoading={isProfileLoading}
                        value={isBrokerAffiliate ? "Yes" : "No"}
                        options={[
                          { value: "Yes", label: "Yes" },
                          { value: "No", label: "No" },
                        ]}
                        onChange={handleBrokerAffiliateChange}
                      />

                      {isBrokerAffiliate && (
                        <div
                          style={{ marginTop: "-10px", marginBottom: "15px" }}
                        >
                          <p
                            style={{
                              fontSize: "12px",
                              color: "#666",
                              marginBottom: "10px",
                              fontFamily: "robotolight",
                            }}
                          >
                            If yes, please select the name of the broker or
                            brokerage from the list.
                          </p>
                          <InputField
                            formRef={formRefs}
                            label="Affiliated Broker / Brokerage"
                            type="dropdown"
                            name="brokerAffiliateName"
                            required
                            placeholder="Select"
                            width="75%"
                            className="mb-1"
                            isProfileLoading={isProfileLoading}
                            value={selectedBrokerageAffiliateName}
                            options={brokerAffiliateNames.map(
                              (affiliate) => affiliate.name
                            )}
                            error={errors["brokerAffiliateName"]}
                            onChange={handleBrokerageNameChange}
                          />
                        </div>
                      )}
                    </>
                  )}
                </form>
              </div>

              {userProfileData?.listingAgent && (
                <div className="col-md-4">
                  <div className="d-flex row">
                    <div className="col-6 col-md-6 col-sm-4">
                      <PhotoUpload
                        currentPhoto={profilePhotoUrl || formData.profilePhoto || '/assets/images/default_profile.png'}
                        onPhotoChange={(file) => handlePhotoUpload(file, false)}
                        isLoading={isProfileLoading}
                        error={errors.profilePhoto}
                      />
                    </div>
                    <div className="col-6 col-md-6 col-sm-4">
                      <PhotoUpload
                        currentPhoto={logoUrl || formData.logo || '/assets/images/no-photo-3x.png'}
                        onPhotoChange={(file) => handlePhotoUpload(file, true)}
                        isLoading={isProfileLoading}
                        error={errors.logo}
                        shouldContain={logoUrl || formData.logo}
                        isLogo={true}
                      />
                    </div>
                  </div>

                  <div className="d-flex align-items-center gap-2 container-website">
                    <div className="input-lable-website" id="lable-website">
                      Website
                    </div>
                    <InputField
                      formRef={formRefs}
                      type="url"
                      name="websiteUrl"
                      key="websiteUrl0"
                      placeholder="Enter Website URL"
                      className="mb-0 flex-1"
                      isProfileLoading={isProfileLoading}
                      value={formData.websiteUrl}
                      error={errors["websiteUrl"]}
                      onChange={(e) =>
                        handleFormFieldChange(e, { name: "websiteUrl" })
                      }
                    />
                  </div>

                  {userType === "AGENT" && (
                    <div className="d-flex align-items-center gap-2 container-website">
                      <div className="input-lable-website" id="lable-linkedin">
                        LinkedIn
                      </div>
                      <InputField
                        formRef={formRefs}
                        type="url"
                        name="linkedinUrl"
                        key="linkedinUrl0"
                        placeholder="Enter LinkedIn URL"
                        className="mb-0 flex-1"
                        isProfileLoading={isProfileLoading}
                        value={formData.linkedinUrl}
                        error={errors["linkedinUrl"]}
                        onChange={(e) =>
                          handleFormFieldChange(e, { name: "linkedinUrl" })
                        }
                      />
                    </div>
                  )}

                  {userType === "AGENT"  && (
                    <BioSection
                      bio={formData.bio}
                      onSave={handleBioSave}
                      onDelete={handleBioDelete}
                      isSaving={isBioSaving}
                    />
                  )}
                </div>
              )}
            </div>

            {showLicenseTable || userType == "AGENT" ? (
              <div className="licenseInfoTable">
                {/* License information */}
                <div className="license-info">
                  <Row className="d-flex justify-content-between align-items-center">
                    <Col sm="auto">
                      <h4 className="required-label">
                        License Information{" "}
                        <span className="input-required-label"></span>
                      </h4>
                    </Col>

                    <Col sm="auto">
                      <Button
                        className="add-license-btn"
                        style={{
                          borderRadius: "50px",
                          display: "flex",
                          alignItems: "center",
                        }}
                        onClick={() => openAddLicenseModal("indv")}
                      >
                        <FaCirclePlus style={{ marginRight: "5px" }} />
                        Add License
                      </Button>
                      <br></br>
                    </Col>

                    {licenseErrMsg !== "" && (
                      <div
                        style={{
                          color: "red",
                          fontSize: 13,
                          fontFamily: "robotomedium",
                          paddingBottom: 5,
                        }}
                      >
                        {licenseErrMsg}
                      </div>
                    )}

                    <LicenseInfoTable
                      onEditClick={handleEditClick}
                      onDeleteLicense={handleDeleteLicense}
                      agentLicenseInfo={agentLicenseInfo}
                      type="Indv"
                    />
                  </Row>
                  <DynamicModal
                    show={showModal}
                    handleClose={() => {
                      setShowModal(false);
                      setErrorSubmitting("");
                    }}
                    fields={licenseFields}
                    onSubmit={
                      licenseType == "Indv"
                        ? handleLicenseFormSubmit
                        : handleCorpLicenseFormSubmit
                    }
                    title={
                      modalMode == "Add"
                        ? `Add License`
                        : `Update License Details`
                    }
                    initialValues={
                      licenseType == "Indv" ? initialValues : initalCorpValues
                    }
                    mode={modalMode}
                    errorSubmitting={errorSubmitting}
                    setLicenseCityDropDown={setLicenseCityDropDown}
                    licenseLoading={licenseLoading}
                  />
                </div>

                {/* corporate License Information */}
                <div className="license-info mt-4">
                  <Row className="d-flex justify-content-between align-items-center">
                    <Col sm="auto">
                      <h4 className="required-label">
                        {" "}
                        Corporate License Information
                      </h4>
                    </Col>
                    <Col sm="auto">
                      <Button
                        className="add-license-btn"
                        style={{
                          borderRadius: "50px",
                          display: "flex",
                          alignItems: "center",
                        }}
                        onClick={() => openAddLicenseModal("Corp")}
                      >
                        <FaCirclePlus style={{ marginRight: "5px" }} />
                        Add License
                      </Button>
                      <br></br>
                    </Col>
                    <LicenseInfoTable
                      onEditClick={handleEditCorpClick}
                      agentLicenseInfo={agentCorpLicenseInfo}
                      onDeleteLicense={handleDeleteCorpLicense}
                      type="Corp"
                    />
                  </Row>

                  {/* <DynamicModal
                          show={showModal}
                          handleClose={() => {
                            setShowModal(false);
                            setEditingLicense(null);
                          }}
                          fields={licenseFields}
                          onSubmit={handleCorpLicenseFormSubmit}
                          mode={modalMode}
                          title={
                            modalMode == "Add"
                            ? "Add New License Corp"
                            : "Update License Details"
                          }
                          initialValues={initalCorpValues}
                        /> */}
                </div>
              </div>
            ) : null}

            <Button
              variant="submit"
              className="btn btn-primary px-2 shadow-sm text-center"
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                fontFamily: "robotolight",
                background: "#1579cc",
                borderColor: "#1579cc",
                // borderRadius: "50px",
                width: "119px",
                height: "48px",
              }}
              onClick={handleUserFormSubmit}
              disabled={isProfileLoading || isLoading}
            >
              {isLoading ? (
                <LoadingText text="Saving..." />
              ) : (
                <LoadedText text="Save" />
              )}
            </Button>

            <br />

            <Button
              className="edit-email-btn mt-1 p-0 pt-2 align-self-start"
              style={{ fontSize: "12px", color: "#428bca" }}
              variant="link"
              onClick={() => {
                setShowConfirmation(true);
                trackButtonClick({
                  eventName: "delete_account_popup_click",
                  eventCategory: "Profile Forms My Shopper",
                  eventLabel: "Open Delete your account Cofirmation popup",
                  eventSource: "on delete your account click",
                });
              }}
              disabled={isProfileLoading || isLoading}
            >
              <span
                className="d-flex align-items-center"
                style={{ fontFamily: "robotoregular" }}
              >
                Delete Your Account
              </span>
            </Button>
          </Container>

          <div>
            {/* Email Change Modal */}
            <ChangeEmailModal
              show={showEmailModal}
              handleClose={handleEmailModalClose}
              onSubmit={handleEmailChange}
              loading={loading}
              currentEmail={currentEmail}
              emailVerification={emailVerification}
              emailVerificationError={emailVerificationError}
              setEmailVerification={setEmailVerification}
              refreshRequired={setShouldRefresh}
            />
          </div>

          <div>
            {/* Set Password Modal */}
            <SetPasswordModal
              show={showPasswordModal}
              handleClose={handlePasswordModalClose}
              onSubmit={handlePasswordSet}
              loading={loading}
              resetEveryThing={resetPasswordModalState}
            />
          </div>
        </div>

        <div className="confirmationModel">
          {showConfirmation && (
            <ConfirmationModel
              show={showConfirmation}
              onHide={() => setShowConfirmation(false)}
              title="Delete your account"
              content={`You will not be able to reactivate your account or retrieve any of the content or information in your account. Are you sure you want to delete your account?<br/><br/><i>Please note that in some cases, we may retain certain information about you as required by law or for legitimate business purposes to the extent permitted by law.</i>`}
              onYes={deleteUserProfile}
              onNo={() => setShowConfirmation(false)}
              loading={loading}
              yesButtonText="Delete Account"
              // noButtonText="Cancel"
              isForDelete={true}
            />
          )}
        </div>
      </div>
      {showIdealogyModal && (
        <IdologyVerification
          show={showIdealogyModal}
          setShowIdologyModal={setShowIdologyModal}
          handleClose={() => setShowIdologyModal(false)}
          userData={formData}
          userProfileData={userProfileData}
          setIdologySuccess={setIdologySuccess}
        />
      )}

      <RoleConfirmationModal
        show={showRoleTypeModal}
        onHide={() => setShowRoleTypeModal(false)}
        title="User Role"
        message={roleMessage}
        onConfirm={handleChangeAgent}
        confirmText="Yes"
        cancelText="No"
      />
    </DashboardSectionWrapper>
  );
};

export default MyProfile;
